import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  shotsTableContainer: {
    marginTop: "5px",
    width: "100%",
  },
  table: {
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },
  tableRow: {
    borderCollapse: "collapse",
    width: "100%",
  },
  tableBody: {
    display: "block",
    overflowY: "auto",
    [theme.breakpoints.down(1205)]: {
      height: `calc(100vh - 300px)`,
    },
    [theme.breakpoints.down(801)]: {
      height: `calc(100vh - 350px)`,
    },
  },
  shotPageTableCell: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.tertiary,
    backgroundColor: theme.palette.primary.main,
    zIndex: "3",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "23.3%",
  },
  shotPageTableCellTwo: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.tertiary,
    backgroundColor: theme.palette.primary.main,
    zIndex: "3",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "15%",
  },
}));

export default useStyles;
